import { generateStringOfN } from "./generateStringOfN";

export const toStringFormatWithNumDigits = (value: number, digits:number = 2) => (generateStringOfN(digits) + value.toString()).slice(-digits)